<template>
  <div
    @mouseenter="onHover"
    @mouseleave="onLeave"
  >
    <Transition name="bounce">
      <div
        v-if="isShow"
        class="tip"
        :style="`${calcPosition(product.x, product.y)}`"
        :class="{'tip-convert': isConvertTips(product.y)}"
      >
        <div
          class="content"
        >
          <div class="left">
            <p><img :src="product.image"></p>
          </div>
          <div class="right">
            <p
              :style="`color:${ product.isInside ? '#1e3ca8' : '#f05050' }`"
            >
              {{ product.title }}
            </p>
            <a
              target="_blank"
              :style="`background-color:${ product.isInside ? '#1e3ca8' : '#f05050' }`"
              :href="product.url"
            >
              {{ product.isInside ? '优惠内购' : '了解更多' }}
            </a>
          </div>
        </div>
        <div
          class="triangle"
          :class="{'triangle-convert': isConvertTips(product.y)}"
        />
      </div>
    </Transition>
    <div
      class="dot"
      :style="`top:${product.y}%;left:${product.x}%`"
    />
  </div>
</template>

<script>
export default {
  name: 'BannerTooltip',
  props: {
    product: {
      type: Object,
      default() {
        return {
          x: 0,
          y: 0,
          title: '空白的啊!',
        };
      },
    },
    delayTime: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      isShow: false,
      timer: null,
    };
  },
  methods: {
    /**
    * 根据提示点(闪动的波点)位置,计算出提示框的位置
    * 需要到顶部边缘情况,所以需要用反转的提示框
    */
    calcPosition(x, y) {
      return `top:calc(${y}% - ${this.isConvertTips(y) ? '-19px' : '102px'});left:calc(${x}% - 73px);`;
    },
    onHover() {
      window.clearTimeout(this.timer);
      window.setTimeout(() => {
        this.isShow = true;
      }, this.delayTime);
    },
    onLeave() {
      this.timer = window.setTimeout(() => {
        this.isShow = false;
      }, this.delayTime);
    },
    isConvertTips(top) {
      // 用百分比估计的弹窗的高度
      const TIP_HEIGHT = 20;
      // 窗口顶部到产品的位置(百分比) < 弹窗的高度
      return top < TIP_HEIGHT;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/animation/pupup.scss';

.tip {
  position: absolute;
  width: 223px;
  height: 93px;
  background-image: url("../../assets/tips/pupup_bg_1.png");
  text-align: left;
  z-index: 200;
  .content {
    position: absolute;
    height: 100%;
    width: 100%;
    .left {
      float: left;
      height: 100%;
      p {
        line-height: 93px;
        img {
          margin: 0 14px;
          width: 71px;
          height: 47px;
          vertical-align: middle;
        }
      }
    }
    .right {
      float: left;
      font-size: 14px;
      p {
        margin: 20px 0 10px 0;
        font-weight: bolder;
        text-align: left;
        line-height: 14px;
        letter-spacing: 0px;
      }
      a {
        display: block;
        border-radius: 15px;
        width: 100px;
        height: 30px;
        text-align: center;
        color: #ffffff;
        line-height: 30px;
        letter-spacing: 0px;
      }
    }
  }

  .triangle {
    position: absolute;
    left: 76px;
    bottom: -10px;
    height: 10px;
    width: 14px;
    background-image: url("../../assets/tips/arrow_1.png");
    background-repeat: no-repeat;
  }

  p {
    font-size: 16px;
  }
}
.dot {
  position: absolute;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.tip-convert {
  background-image: url("../../assets/tips/pupup_bg_2.png");
}

.triangle-convert {
  background-image: url("../../assets/tips/arrow_2.png") !important;
  top: -9px;
}

.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
